module.exports = __webpack_public_path__ + "static/media/YM35_3.fd2c2ef6.jpg";